
const IS_NOT_PRODUCTION = window.location.toString().indexOf('ghost') > -1 || window.location.toString().indexOf('local') > -1;


//
// Import Controller Library
//

var Controllers = {
  'global':      require('./global'),
  'admin':       require('./admin'),
  'commissions': require('./commissions')
};


//
// Controller Detection and Initialisation
//

exports.initAllWithin = function initAllWithin (subdom) {
  subdom.querySelectorAll('[data-controller]').forEach(function (el) {
    var types = el.dataset.controller.split(' ');

    types.forEach(function (type) {
      if (Controllers[type]) {
        Controllers[type]($(el), findInside(el));
      } else if (type !== '') {
        console.warn('No such controller:', type);
      }
    });
  });
}
